import { ButtonProps } from "@mui/material";
import PlusIcon from "assets/icons/PlusIcon";
import BasicButton from "components/BasicInputs/BasicButton";

export default function AddBtn(props: ButtonProps) {
  return (
    <BasicButton
      className="min-w-[32px] min-h-[32px] p-0 rounded-full cursor-pointer flex justify-center items-center border border-dashed border-gray-400"
      {...props}
    >
      <div className="w-6 h-6 shadow-[0_0_10px_rgba(0,0,0,0.3)] rounded-full flex justify-center items-center">
        <PlusIcon scale={0.6} color="#7E8C9E" />
      </div>
    </BasicButton>
  );
}
